import { SVGProps } from 'react';

export function DistributionCenter(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <rect
        width='24'
        height='24'
        rx='2'
        fill='#FFF6D3'
      />
      <g clipPath='url(#clip0_1415_53459)'>
        <path
          d='M12.667 11.334H15.3337V16.6673H8.66699V12.6673H12.667'
          stroke='#DB941B'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.6667 16.6667V10.6667C12.6667 10.4899 12.5964 10.3203 12.4714 10.1953C12.3464 10.0702 12.1768 10 12 10H10.6667C10.4899 10 10.3203 10.0702 10.1953 10.1953C10.0702 10.3203 10 10.4899 10 10.6667V12.6667'
          stroke='#DB941B'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6 18.313L6.03334 10.293C6.03334 9.88631 6.22667 9.49968 6.54667 9.24635L11.2133 5.61301C11.6933 5.23967 12.3667 5.23967 12.8533 5.61301L17.52 9.23968C17.8467 9.49301 18.0333 9.87965 18.0333 10.293V18.313'
          stroke='#DB941B'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5.33325 18.667H18.6666'
          stroke='#DB941B'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1415_53459'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(4 4)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
